import { useGetDirectMessageStatusQuery } from 'generated/graphql';
import { getDmEnabled } from '@client/new/common/features.helpers';

export const useDmFeatureEnabled = (influencerId: number) => {
  const { data, loading } = useGetDirectMessageStatusQuery({
    variables: { id: influencerId },
    skip: !influencerId,
  });

  return {
    isDmFeatureEnabled: getDmEnabled(data?.creator?.features),
    isLoading: loading,
  };
};
